<section class="job-financials" *ngIf="viewModel$ | async as viewModel">
  <div>
    <header class="p-my-2">
      <h2>Invoices</h2>
      <p-button
        label="Invoice"
        icon="pi pi-plus"
        outlined="true"
        (onClick)="store.dispatch(actions.addInvoiceButtonClicked())"
        [disabled]="!viewModel.jobLoaded || viewModel.mutationButtonsDisabled"
      ></p-button>
    </header>
    <div class="document-container">
      <p-skeleton
        *ngIf="!viewModel.jobLoaded"
        class="flex-1"
        borderRadius="0.571rem"
        width="100%"
        height="6.25rem"
      ></p-skeleton>
      <div class="empty-state" *ngIf="viewModel.invoicesEmpty">
        <i class="pi pi-file"></i>
        <span>No invoices for this job.</span>
      </div>
      <app-job-invoice
        *ngIf="viewModel.latestInvoice"
        [invoiceId]="viewModel.latestInvoice.id"
      ></app-job-invoice>
      <ng-container *ngIf="viewModel.olderInvoices">
        <ng-container *ngIf="showMoreInvoices">
          <app-job-invoice
            *ngFor="let invoice of viewModel.olderInvoices"
            [invoiceId]="invoice.id"
          ></app-job-invoice>
        </ng-container>
        <span
          *ngIf="viewModel.olderInvoices.length"
          class="show-more"
          (click)="showMoreInvoices = !showMoreInvoices"
          >{{ showMoreInvoices ? 'Hide' : 'Show' }} older invoices ({{
            viewModel.olderInvoices.length
          }})</span
        >
      </ng-container>
    </div>
  </div>
  <div>
    <header class="p-my-2">
      <h2>Transactions</h2>
      <p-button
        label="Take Payment"
        icon="pi pi-plus"
        [disabled]="!viewModel.jobLoaded || !viewModel.createTransaction?.enabled"
        (onClick)="store.dispatch(paymentActions.createTransactionButtonClicked({
          jobId: viewModel.createTransaction.jobId,
          customerId: viewModel.createTransaction.customerId,
          currency: viewModel.createTransaction.currency
        }))"
      ></p-button>
    </header>
    <p-skeleton
      *ngIf="!viewModel.jobLoaded"
      width="100%"
      height="8rem"
      borderRadius="0"
    ></p-skeleton>
    <div class="empty-state" *ngIf="viewModel.transactionsEmpty">
      <i class="pi pi-credit-card"></i>
      <span>No transactions for this job.</span>
    </div>
    <p-table
      *ngIf="!viewModel.transactionsEmpty"
      [value]="viewModel.transactions"
      [lazy]="true"
      breakpoint="620px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">Remarks</th>
          <th class="p-text-center" style="width: 10rem">Status</th>
          <th style="width: 15rem">Payment</th>
          <th style="width: 15rem">Invoice</th>
          <th style="width: 1rem"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-t>
        <tr
          (click)="
            store.dispatch(
              actions.transactionRowClicked({ transactionId: t.id })
            )
          "
          style="cursor: pointer"
        >
          <td class="expand-column">
            <i
              *ngIf="t.hasRemarks"
              class="pi expand-chevron"
              [ngClass]="
                t.expandRemarks ? 'pi-chevron-down' : 'pi-chevron-right'
              "
              (click)="
                store.dispatch(
                  actions.transactionRemarksToggled({ transactionId: t.id })
                )
              "
            ></i>
            <span *ngIf="!t.hasRemarks" class="p-text-italic">No remarks</span>
          </td>
          <td class="p-text-center">
            <span class="p-column-title">Status</span>
            <div class="status-with-date">
              <p-tag
                rounded="true"
                [style]="{
                  backgroundColor:
                    colorMap[t.deletedAt ? 'deleted' : t.stage]?.backgroundColor || '#F0F4F8',
                  color: colorMap[t.deletedAt ? 'deleted' : t.stage]?.text || '#32383E',
                }"
                [value]="t.deletedAt ? 'Deleted' : (t.stage | titlecase)"
                styleClass="p-ml-2"
              ></p-tag>
              <div class="date-text">
                {{ (t.paidAt || t.createdAt) | freyaDate: 'MMM d, y' }}
              </div>
              <div class="date-text">
                {{ (t.paidAt || t.createdAt) | freyaDate: 'h:mm a' }}
              </div>
              <!-- "Pending" alone, over money that has already left a card, reads
                   as a failed payment — and an operator who reads it that way
                   takes a second one. -->
              <div class="p-text-secondary p-text-sm" *ngIf="describePending(t) as pending">
                {{ pending }}
              </div>
              <!-- A cancelled refund leg moved NO money. Left unexplained it
                   reads as a refund that failed silently — which is exactly how
                   a release of a hold the device no longer held was read. -->
              <div class="p-text-sm" *ngIf="describeRefundFailure(t) as failure">
                {{ failure }}
              </div>
            </div>
          </td>
          <td>
            <span class="p-column-title">Payment</span>
            <div class="payment-with-amount">
              <div class="payment-type">
                {{ t.type | titlecase }} ({{ t.paymentType?.name }})
              </div>
              <!-- `type` says how the money was FILED; this says what it
                   actually is. An open authorization is money HELD on a
                   customer's card and was indistinguishable from a settled sale
                   on this row. -->
              <div class="p-text-secondary p-text-sm" *ngIf="describeRail(t) as rail">
                {{ rail }}
              </div>
              <div class="amount-text">
                {{ t.amount / 100 | currency: t.currency }}
              </div>
            </div>
          </td>
          <td>
            <span class="p-column-title">Invoice</span>
            <p-tag
              *ngIf="t.invoice"
              [value]="t.invoiceName"
              icon="pi pi-file"
              [style]="{
                backgroundColor: '#F0F4F8',
                color: '#32383E',
              }"
              styleClass="clickable-tag"
              (click)="
                store.dispatch(
                  actions.transactionInvoiceTagClicked({
                    invoiceId: t.invoice.id,
                  })
                );
                $event.stopPropagation()
              "
            ></p-tag>
            <span *ngIf="!t.invoice" class="p-text-italic"
              >No Active Invoice</span
            >
          </td>
          <td style="text-align: right">
            <p-button
              icon="pi pi-ellipsis-v"
              text="true"
              (onClick)="
                store.dispatch(
                  actions.openTransactionsActionsMenuButtonClicked({
                    transactionId: t.id,
                  })
                );
                menu.toggle($event);
                $event.stopPropagation()
              "
            ></p-button>
            <p-menu
              #menu
              [popup]="true"
              appendTo="body"
              [model]="viewModel.transactionActions"
            ></p-menu>
          </td>
        </tr>
        <tr *ngIf="t.hasRemarks && t.expandRemarks" class="remarks-row">
          <td colspan="5" class="remarks-cell">
            <quill-editor
              class="remarks-content"
              [readOnly]="true"
              [ngModel]="t.remarks"
              [modules]="{ toolbar: false }"
              placeholder="No remarks"
              format="object"
            ></quill-editor>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div>
    <header class="p-my-2">
      <h2>Damages</h2>
      <p-button
        *hasPermission="['charges.create']"
        label="Damages"
        icon="pi pi-plus"
        outlined="true"
        (onClick)="store.dispatch(actions.addDamageButtonClicked())"
        [disabled]="!viewModel.jobLoaded || viewModel.mutationButtonsDisabled"
      ></p-button>
    </header>
    <p-skeleton
      *ngIf="!viewModel.jobLoaded"
      width="100%"
      height="8rem"
      borderRadius="0"
    ></p-skeleton>
    <div class="empty-state" *ngIf="viewModel.damagesEmpty">
      <i class="pi pi-exclamation-circle"></i>
      <span>No damages for this job.</span>
    </div>
    <p-table
      *ngIf="!viewModel.damagesEmpty"
      [value]="viewModel.damages"
      [lazy]="true"
      breakpoint="620px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th colspan="3">Name</th>
          <th>Amount</th>
          <th>Quantity</th>
          <th>Subtotal</th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-d>
        <tr>
          <td colspan="3">
            <span class="p-column-title">Name</span>
            {{ d?.product?.name || d?.productName }}
          </td>
          <td>
            <span class="p-column-title">Amount</span>
            {{ d | chargeAmount | currency: job?.currency || 'USD' }}
          </td>
          <td>
            <span class="p-column-title">Quantity</span>
            <span>
              {{ d?.quantity }}
            </span>
          </td>
          <td>
            <span class="p-column-title">Subtotal</span>
            {{ d?.chargeSubTotal / 100 | currency: job?.currency || 'USD' }}
          </td>
          <td></td>
          <td style="text-align: right">
            <p-button
              icon="pi pi-ellipsis-v"
              text="true"
              (onClick)="
                store.dispatch(
                  actions.openDamageActionsMenuButtonClicked({ damageId: d.id })
                );
                menu.toggle($event)
              "
              [disabled]="
                viewModel.mutationButtonsDisabled ||
                d?.calendarEvent?.locked ||
                d?.calendarEvent?.invoiced
              "
            ></p-button>
            <p-menu
              #menu
              [popup]="true"
              appendTo="body"
              [model]="viewModel.damageActions"
            ></p-menu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<!-- The refund dialog. Hosted here because Refund is a row-menu action on
     this table; the dialog owns its own NgRx feature and reads nothing from
     this component. -->
<app-bluesage-refund-dialog></app-bluesage-refund-dialog>
